import { FC, useContext } from "react";

import { PaymentMethod } from "@simplyk/common";

import { FrontendFormContext } from "@/common/contexts/FrontendFormContext";
import { useTranslate } from "@/common/hooks/useTranslate";
import { FormTypography } from "@/forms-design-system/FormTypography";

export const DafTipNotice: FC = () => {
  const { selectedPaymentMethod } = useContext(FrontendFormContext);
  const { t } = useTranslate();
  return selectedPaymentMethod === PaymentMethod.Daf ? (
    <FormTypography variant="subtitle1" vibe="quiet">
      {t("common", "daf.noTip")}
    </FormTypography>
  ) : null;
};
